/* unplugin-vue-components disabled */import { render } from "./ComprehensiveDaily.vue?vue&type=template&id=13813264&scoped=true&ts=true"
import script from "./ComprehensiveDaily.vue?vue&type=script&lang=ts"
export * from "./ComprehensiveDaily.vue?vue&type=script&lang=ts"

import "./ComprehensiveDaily.vue?vue&type=style&index=0&id=13813264&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13813264"]])

export default __exports__